import { useQuery } from "@tanstack/react-query";
import type { CurrentUser } from "@qlik-scheduler/shared";

import { apiRequest } from "../api/client.js";

// GET /api/auth/me — the API endpoint is implemented in Wave 4 by another
// agent. If the cookie has lapsed, apiRequest's 401 handler will top-frame
// redirect to the SSO bounce before this query ever sees the error.
export function useCurrentUser() {
  return useQuery<CurrentUser>({
    queryKey: ["auth", "me"],
    queryFn: ({ signal }) => apiRequest<CurrentUser>("/api/auth/me", { signal }),
    staleTime: 60_000,
    retry: false,
  });
}
